import React from "react";

import VideoAbout from "../../assets/presentation.mp4";
import Poster from "../../assets/poster.png";

function Video() {
  return (
    <div className="video-container">
      <div className="video-copy">
        <span className="video-copy-kicker">Demonstracao guiada</span>
        <h3 className="video-copy-title">Saiba mais sobre a EasyVog</h3>
        <p className="video-copy-description">
          Veja como a plataforma organiza processos, financeiro e produtividade
          em uma experiencia clara, moderna e facil de navegar.
        </p>
      </div>

      <video
        className="shadow-lg"
        controls="controls"
        preload="none"
        poster={Poster}
      >
        <source id="mp4" src={VideoAbout} type="video/mp4" />
        <source id="webm" src={VideoAbout} type="video/webm" />
        <source id="ogv" src={VideoAbout} type="video/ogg" />
      </video>
    </div>
  );
}

export default Video;
